import { render } from "./CommentUserBalloon.vue?vue&type=template&id=4410bf56"
import script from "./CommentUserBalloon.vue?vue&type=script&lang=js"
export * from "./CommentUserBalloon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__